import { createSchema, createValidation } from '../../../../utils/validator';

export const inviteValidationSchema = (t) =>
  createSchema({
    learner: createValidation().exist(t('error.fieldRequired')),
  });
